import { useMemo } from "react";
import { setActiveOrganization } from "@redux/Organization";
import { useAppDispatch, useAppSelector } from "@configs/Redux";
import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from "@resources/Constants";
import useAccessibleOrganizations from "./resources/useAccessibleOrganizations";

export default function useOrganization() {
  const { data: organizations, refetch } = useAccessibleOrganizations();
  const { orgId } = useAppSelector((state) => state.organization);
  const dispatch = useAppDispatch();

  const organization = useMemo(
    () =>
      organizations?.find((org) => org.orgId === orgId) || organizations?.[0],
    [orgId, organizations]
  );

  const setOrganization = (orgId: string) => {
    localStorage.setItem(LOCAL_STORAGE_KEY.ORG_ID, orgId);
    sessionStorage.setItem(SESSION_STORAGE_KEY.ORG_ID, orgId);
    dispatch(setActiveOrganization(orgId));
  };

  return {
    organization,
    orgId,
    refetch,
    setOrganization
  };
}
